var aux = require("./__aux");
var i18nLib = require("../i18n");


exports.getRoomTabTemplate = getRoomTabTemplate;
exports.getRoomsAvailables = getRoomsAvailables;

var roomAvaibility = {
	adults1: {
		tab1: {
			room1: {
				children0: ["SG"],
				children1: ["DB", "TW"],
				children2: ["DBE"],
				children3: ["QD"],
				children4: ["QD"],
				children5: ["QD"],
				children6: ["QD"],
				children7: ["QD"],
				children8: ["QD"],
				children9: ["QD"],
				children10: ["QD"]
			}
		}
	},
	adults2: {
		tab1: {
			room1: {
				children0: ["DB", "TW"],
				children1: ["DBE"],
				children2: ["QD"],
				children3: ["QD"],
				children4: ["QD"],
				children5: ["QD"],
				children6: ["QD"],
				children7: ["QD"],
				children8: ["QD"],
				children9: ["QD"],
				children10: ["QD"]
			},
		},
		tab2: {
			room1: {
				children0: ["SG"],
				children1: ["DB", "TW"],
				children2: ["DB", "TW", "DBE"],
				children3: ["DBE"],
				children4: ["DBE"],
				children5: ["QD"],
				children6: ["QD"],
				children7: ["QD"],
				children8: ["QD"],
				children9: ["QD"],
				children10: ["QD"]
			},
			room2: {
				children0: ["SG"],
				children1: ["SG"],
				children2: ["SG", "DB", "TW"],
				children3: ["DB", "TW"],
				children4: ["DBE"],
				children5: ["DBE"],
				children6: ["QD"],
				children7: ["QD"],
				children8: ["QD"],
				children9: ["QD"],
				children10: ["QD"]
			}
		}
	},
	adults3: {
		tab1: {
			room1: {
				children0: ["TR"],
				children1: ["QD"],
				children2: ["QD"],
				children3: ["QD"],
				children4: ["QD"],
				children5: ["QD"],
				children6: ["QD"],
				children7: ["QD"],
				children8: ["QD"],
				children9: ["QD"],
				children10: ["QD"]
			}
		},
		tab2: {
			room1: {
				children0: ["DB", "TW"],
				children1: ["DB", "TW", "DBE"],
				children2: ["DBE"],
				children3: ["DBE", "QD"],
				children4: ["DBE", "QD"],
				children5: ["QD"],
				children6: ["QD"],
				children7: ["QD"],
				children8: ["QD"],
				children9: ["QD"],
				children10: ["QD"]
			},
			room2: {
				children0: ["SG"],
				children1: ["DB", "TW"],
				children2: ["DB", "TW"],
				children3: ["DB", "TW", "DBE"],
				children4: ["DBE", "QD"],
				children5: ["QD"],
				children6: ["QD"],
				children7: ["QD"],
				children8: ["QD"],
				children9: ["QD"],
				children10: ["QD"]
			}
		},
		tab3: {
			room1: {
				children0: ["SG"],
				children1: ["DB", "TW"],
				children2: ["DB", "TW", "DBE"],
				children3: ["DB", "TW", "DBE", "QD"],
				children4: ["DBE", "TR", "QD"],
				children5: ["DBE", "TR", "QD"],
				children6: ["DBE", "TR", "QD"],
				children7: ["DBE", "TR", "QD"],
				children8: ["QD"],
				children9: ["QD"],
				children10: ["QD"]
			},
			room2: {
				children0: ["SG"],
				children1: ["SG"],
				children2: ["SG", "DB", "TW"],
				children3: ["SG", "DB", "TW"],
				children4: ["DB", "TW", "DBE"],
				children5: ["DB", "TW", "DBE"],
				children6: ["DBE", "QD"],
				children7: ["DBE", "QD"],
				children8: ["QD"],
				children9: ["QD"],
				children10: ["QD"]
			},
			room3: {
				children0: ["SG"],
				children1: ["SG"],
				children2: ["SG"],
				children3: ["SG", "DB", "TW"],
				children4: ["SG", "DB", "TW"],
				children5: ["SG", "DB"],
				children6: ["SG", "DBE"],
				children7: ["DB", "TW"],
				children8: ["DBE"],
				children9: ["QD"],
				children10: ["QD"]
			}
		}
	},
	adults4: {
		tab1: {
			room1: {
				children0: ["QD"],
				children1: ["QD"],
				children2: ["QD"],
				children3: ["QD"],
				children4: ["QD"],
				children5: ["QD"],
				children6: ["QD"],
				children7: ["QD"],
				children8: ["QD"],
				children9: ["QD"],
				children10: ["QD"]
			}
		},
		tab2: {
			room1: {
				children0: ["DB", "TW", "TR"],
				children1: ["DBE", "QD"],
				children2: ["DBE", "QD"],
				children3: ["QD"],
				children4: ["QD"],
				children5: ["QD"],
				children6: ["QD"],
				children7: ["QD"],
				children8: ["QD"],
				children9: ["QD"],
				children10: ["QD"]
			},
			room2: {
				children0: ["SG", "DB", "TW"],
				children1: ["SG", "DB", "TW"],
				children2: ["SG", "DBE"],
				children3: ["QD"],
				children4: ["QD"],
				children5: ["QD"],
				children6: ["QD"],
				children7: ["QD"],
				children8: ["QD"],
				children9: ["QD"],
				children10: ["QD"]
			}
		},
		tab3: {
			room1: {
				children0: ["DB", "TW"],
				children1: ["DBE"],
				children2: ["DB", "TW", "DBE"],
				children3: ["DB", "TW", "DBE", "QD"],
				children4: ["DB", "TW", "DBE", "QD"],
				children5: ["QD"],
				children6: ["QD"],
				children7: ["QD"],
				children8: ["QD"],
				children9: ["QD"],
				children10: ["QD"]
			},
			room2: {
				children0: ["SG"],
				children1: ["SG"],
				children2: ["DB", "TW"],
				children3: ["DB", "TW", "DBE"],
				children4: ["DB", "TW", "DBE"],
				children5: ["QD"],
				children6: ["QD"],
				children7: ["QD"],
				children8: ["QD"],
				children9: ["QD"],
				children10: ["QD"]
			},
			room3: {
				children0: ["SG"],
				children1: ["SG"],
				children2: ["SG", "DB", "TW"],
				children3: ["SG", "DB", "TW"],
				children4: ["SG", "DB", "TW", "DBE"],
				children5: ["QD"],
				children6: ["QD"],
				children7: ["QD"],
				children8: ["QD"],
				children9: ["QD"],
				children10: ["QD"]
			}
		},
		tab4: {
			room1: {
				children0: ["SG"],
				children1: ["DBE"],
				children2: ["DB", "TW", "DBE"],
				children3: ["DB", "TW", "DBE", "QD"],
				children4: ["DB", "TW", "DBE", "QD"],
				children5: ["QD"],
				children6: ["QD"],
				children7: ["QD"],
				children8: ["QD"],
				children9: ["QD"],
				children10: ["QD"]
			},
			room2: {
				children0: ["SG"],
				children1: ["SG"],
				children2: ["DB", "TW"],
				children3: ["DB", "TW", "DBE"],
				children4: ["DB", "TW", "DBE"],
				children5: ["QD"],
				children6: ["QD"],
				children7: ["QD"],
				children8: ["QD"],
				children9: ["QD"],
				children10: ["QD"]
			},
			room3: {
				children0: ["SG"],
				children1: ["SG"],
				children2: ["SG", "DB", "TW"],
				children3: ["SG", "DB", "TW"],
				children4: ["SG", "DB", "TW"],
				children5: ["QD"],
				children6: ["QD"],
				children7: ["QD"],
				children8: ["QD"],
				children9: ["QD"],
				children10: ["QD"]
			},
			room4: {
				children0: ["SG"],
				children1: ["SG"],
				children2: ["SG", "DB", "TW"],
				children3: ["SG", "DB", "TW"],
				children4: ["SG", "DB", "TW"],
				children5: ["QD"],
				children6: ["QD"],
				children7: ["QD"],
				children8: ["QD"],
				children9: ["QD"],
				children10: ["QD"]
			}
		}
	},
	adults5: {
		tab2: ["SG", "DB", "DBE", "TW", "TR", "QD"],
		tab3: ["SG", "DB", "DBE", "TW", "TR"],
		tab4: ["SG", "DB", "DBE", "TW"],
		tab5: ["SG"]
	},
	adults6: {
		tab2: ["DB", "TW", "DBE", "TR", "QD"],
		tab3: ["SG", "DB", "TW", "TR"],
		tab4: ["SG", "DB"],
		tab5: ["SG", "DB"],
		tab6: ["SG"]
	},
	adults7: {
		tab2: ["QD", "TR"],
		tab3: ["SG", "DB", "DBE", "TW", "TR"],
		tab4: ["SG", "DB", "DBE", "TW", "TR", "QD"],
		tab5: ["SG", "DB", "DBE", "TW", "TR"],
		tab6: ["SG", "DB", "DBE", "TW"],
		tab7: ["SG"]
	},
	adults8: {
		tab2: ["QD"],
		tab3: ["DB", "DBE", "TW", "TR", "QD"],
		tab4: ["SG", "DB", "DBE", "TW", "TR", "QD"],
		tab5: ["SG", "DB", "DBE", "TW", "TR", "QD"],
		tab6: ["SG", "DB", "DBE", "TW", "TR", "QD"],
		tab7: ["SG", "DB", "DBE", "TW", "TR", "QD"],
		tab8: ["SG"]
	},
	adults9: {
		tab3: ["SG", "DB", "DBE", "TW", "TR", "QD"],
		tab4: ["SG", "DB", "DBE", "TW", "TR", "QD"],
		tab5: ["SG", "DB", "DBE", "TW", "TR", "QD"],
		tab6: ["SG", "DB", "DBE", "TW", "TR", "QD"],
		tab7: ["SG", "DB", "DBE", "TW", "TR", "QD"],
		tab8: ["SG", "DB", "DBE", "TW", "TR", "QD"],
		tab9: ["SG"]
	},
	adults10: {
		tab3: ["DB", "DBE", "TW", "TR", "QD"],
		tab4: ["SG", "DB", "DBE", "TW", "TR", "QD"],
		tab5: ["SG", "DB", "DBE", "TW", "TR", "QD"],
		tab6: ["SG", "DB", "DBE", "TW", "TR", "QD"],
		tab7: ["SG", "DB", "DBE", "TW", "TR", "QD"],
		tab8: ["SG", "DB", "DBE", "TW", "TR", "QD"],
		tab9: ["SG", "DB", "DBE", "TW", "TR", "QD"],
		tab10: ["SG"]
	}
}

function getRoomTabTemplate(divId, adults, children, infants, index, roomsAvailables) {
	//Check if there is room available
	var isAvailable = false;
	roomsAvailables.forEach(function (option) {
		if (option.length == index) {
			isAvailable = true;
		}
	});

	if (isAvailable) {
		var activeClass = ""; //travelersCount == index ? "active" : "";
		var roomTabTemplate = '<li role="presentation" class="' + activeClass + '">';
		roomTabTemplate += '<a href="#tabPanel' + index + '" id="tab' + index + '" role="tab" data-toggle="tab" aria-controls="number' + index + '" aria-expanded="true">' + index + '</a>';
		roomTabTemplate += '</li>';

		var firstId = $($("#roomTabs").children()[0]).find("a").attr("id");
		if ($(divId).find("#tab" + index).length === 0) {
			if (firstId && firstId.split("tab")[1] > index) {
				$(divId).prepend(roomTabTemplate);
			} else {
				//Remove the other elements to do the append
				for (var j = 0; j < $('#roomTabs a[id*=tab]').length; j++) {
					var tabItem = $($('#roomTabs a[id*=tab]')[j]).attr('id');
					if (tabItem) {
						var tabItemI = tabItem.replace('tab', '');
						tabItemI = parseInt(tabItemI)
						if (!isNaN(tabItemI)) {
							if (tabItemI >= index) {
								$("#roomTabs").find("#" + tabItem).parent().remove();
								$("#tabPanel" + (tabItemI)).remove();
							}
						}
					}
				}
				$(divId).append(roomTabTemplate);
			}
		}

		$("#tabContent").append(getRoomSelectorTemplate(index, adults, children, infants, roomsAvailables));
	} else {
		$("#roomTabs").find("#tab" + index).parent().remove();
		$("#tabPanel" + (index)).remove();
	}
}

function sortByGuests(a, b) {
	return parseInt($(a).data("max-adults") < $(b).data("max-adults"))
}

function getRoomSelectorTemplate(index, adults, children, infants, roomsAvailables) {
	var roomSelectorTemplate = '<div role="tabpanel" class="tab-pane" id="tabPanel' + index + '" aria-labelledby="tab' + index + '">';
	roomSelectorTemplate += '<div class="row">';

	var roomTypes = [];
	$("[data-booking='roomType']").sort(sortByGuests).each(function () {
		roomTypes.push($(this).data("tourplan-type"));
	});

	var roomIndex = 1;

	for (var i = 0; i < index; i++) {
		var remainingTravelers = adults;
		var firstRoom = $("[data-booking='roomType']").sort(sortByGuests);
		roomSelectorTemplate += '<div class="col-sm-6 col-md-6 col-lg-6">';
		roomSelectorTemplate += '<label>' + aux.getGuestOrdinal((i + 1)) +  ' ' + i18nLib.localize('room') + '</label>';
		roomSelectorTemplate += '<div class="booking-select">';
		roomSelectorTemplate += '<select class="numbers-rooms" style="width: 100%" name="roomCfg_' + index + '_' + i + '" data-booking-select="roomConfig">';
		roomSelectorTemplate += '<option value="" selected disabled>' + i18nLib.localize('Select room type') + '</option>'

		$("[data-booking='roomType']").sort(sortByGuests).each(function () {

			var room = this;

			roomsAvailables.forEach(function (option) {
				if (option.length == index) {
					for (var j = 0; j < option.length; j++) {
						if ((option[j].trim() == $(room).data("tourplan-type").trim()) && (j == i)) {
							roomSelectorTemplate += '<option value="' + $(room).val() + '" ' +
								'data-description="' + $(room).data("description") + '"' +
								'data-max-adults="' + $(room).data("max-adults") + '"' +
								'data-max-guests="' + $(room).data("max-guests") + '"' +
								'data-tourplan-type="' + $(room).data("tourplan-type") + '"' +
								'>' + $(room).data("name") + '</option>';
						}
					}
				}
			});
		});

		roomSelectorTemplate += '</select>';
		roomSelectorTemplate += '</div>';
		roomSelectorTemplate += '</div>';
		$("[name='roomCfg_" + index + "_" + i + "']").val($(firstRoom.val())).trigger("change");
		roomIndex++;
	}
	roomSelectorTemplate += '</div>';
	roomSelectorTemplate += '</div>';

	return roomSelectorTemplate;
}

//Generate the possible combinations based on array (arr) and possibilities (k) 
function generateCombinations(arr, k) {
	var i,
		subI,
		ret = [],
		sub,
		next;
	for (i = 0; i < arr.length; i++) {
		if (k === 1) {
			ret.push([arr[i]]);
		} else {
			sub = generateCombinations(arr.slice(i + 1, arr.length), k - 1);
			for (subI = 0; subI < sub.length; subI++) {
				next = sub[subI];
				next.unshift(arr[i]);
				ret.push(next);
			}
		}
	}
	return ret;
}

function sortCombinationsByAdults(rooms) {

	var oRooms = [];
	var order = ["DB", "TW", "DBE", "TR", "QD", "SG"]; //There is XX room and it is just avoid duplication in room select

	rooms.forEach(function (room) {
		if (room.length > 1) {
			var aux = [];
			order.forEach(function (od) {
				room.forEach(function (item) {
					if (item == od) {
						aux.push(item);
					}
				});
			});

			oRooms.push(aux);
		} else {
			oRooms.push(room);
		}
	});

	return oRooms;
}

function removedDuplicatedCombinations(rooms) {

	var dRooms = [];
	var max = 0;
	rooms.forEach(function (room) {
		if (room.length > max) {
			max = room.length;
		}
	});

	for (var i = 0; i < max; i++) {
		var aux = [];
		var aux1 = -1;
		rooms.forEach(function (room) {
			if (aux1 != room.length) {
				aux1 = -1;
				aux = [];
			}

			if (i < room.length) {
				if (aux.indexOf(room[i]) < 0) {
					aux.push(room[i]);
					aux1 = room.length;
				} else {
					if (aux1 == room.length) {
						room[i] = "XX";
					}
				}
			}
		});
	}

	return dRooms;
}

function getRoomsCombinations(adults, tourRooms) {

	if (!(adults > 0)) {
		return [];
	}

	var roomsP = tourRooms;

	//var duplicate = Math.floor(adults / 4); //For each 4 adults, we duplicate the tourRooms
	//var duplicate = adults;
	var duplicate = 1;
	if (adults <= 4) {
		duplicate = 1;
	} else if (adults <= 6) {
		duplicate = 3;
	} else {
		duplicate = 2;
	}

	duplicate = duplicate > 2 ? 2 : 1; //Avoid explosive combinations
	for (var i = 0; i < duplicate; i++) {
		roomsP = roomsP.concat(tourRooms);
	}

	var combinations = []
	for (var i = 0; i < adults; i++) {
		var aux = generateCombinations(roomsP, i + 1, adults, 0);//Make combinations to 2, 3
		combinations = combinations.concat(aux);
	}

	//	//Replicate the rooms
	if (adults <= 10) {
		for (i = 0; i < tourRooms.length; i++) {
			var aux = [];

			for (var j = 0; j < adults; j++) {
				aux[j] = tourRooms[i];
			}

			combinations.push(aux);
		}
	}

	return combinations;
}

//Fix some room combinations because of the rooms
function removeRoomCombinations(that, adults, children, rooms) {

	rooms.forEach(function (room) {

		//Remove family room option
		if (room.length == 2 && adults == 6) {
			room[0] = "XX";
			room[1] = "XX";
		}

		if (room.length == 2 && adults == 5 && children > 2) {
			room[0] = "XX";
			room[1] = "XX";
		}

		if (room.length == 3 && adults == 7) {
			room[0] = "XX";
			room[1] = "XX";
			room[2] = "XX";
		}
		if (room.length == 3 && adults == 8) {
			room[0] = "XX";
			room[1] = "XX";
			room[2] = "XX";
		}

		if (room.length == 4 && adults == 8 && children == 5) {
			room[0] = "XX";
			room[1] = "XX";
			room[2] = "XX";
		}

		if (room.length == 3 && adults == 9) {
			room[0] = "XX";
			room[1] = "XX";
			room[2] = "XX";
		}

		if (room.length == 4 && adults == 10) {
			room[0] = "XX";
			room[1] = "XX";
			room[2] = "XX";
			room[3] = "XX";
		}
	});

	return rooms;
}

function fixRoomCombinations5Adults(adults, children, room) {
	if (room.length == 2
		&& adults == 5
		&& room[0] == "DBE") {
		room[0] = "TR"; // Replace DBE option by TR
	}

	if (room.length == 4
		&& adults == 5
		&& children == 3) {

		if (room[0] == "DB") {
			room[0] = "";
		}

		if (room[1] == "DB") {
			room[1] = "";
		}

		if (room[0] == "TW") {
			room[0] = "";
		}

		if (room[1] == "TW") {
			room[1] = "";
		}

		if (room[3] == "TW") {
			room[3] = "";
		}
	}

	if (room.length == 5
		&& adults == 5
		&& children == 3) {

		if (room[1] == "DBE") {
			room[1] = "";
		}
	}

	if (room.length == 4
		&& adults == 5
		&& children == 4) {

		if (room[0] == "DBE") {
			room[0] = "";
		}

		if (room[1] == "DBE") {
			room[1] = "";
		}
	}

	if (room.length == 5
		&& adults == 5
		&& children == 4) {

		if (room[0] == "DB") {
			room[0] = "";
		}

		if (room[0] == "TW") {
			room[0] = "";
		}

		if (room[1] == "DB") {
			room[1] = "";
		}

		if (room[1] == "TW") {
			room[1] = "";
		}
	}

	if (room.length == 4
		&& adults == 5
		&& children == 5) {

		if (room[0] == "DB") {
			room[0] = "";
		}

		if (room[0] == "TW") {
			room[0] = "";
		}

		if (room[0] == "DBE") {
			room[0] = "";
		}

		if (room[1] == "DB") {
			room[1] = "";
		}

		if (room[1] == "TW") {
			room[1] = "";
		}

		if (room[1] == "QD") {
			room[1] = "";
		}
	}

	if (room.length == 5
		&& adults == 5
		&& children == 5) {

		if (room[0] == "DB") {
			room[0] = "";
		}

		if (room[0] == "TW") {
			room[0] = "";
		}

		if (room[1] == "DB") {
			room[1] = "";
		}

		if (room[1] == "TW") {
			room[1] = "";
		}

		if (room[1] == "QD") {
			room[1] = "";
		}
	}

	if (room.length == 4
		&& adults == 5
		&& children == 6) {

		if (room[0] == "DB") {
			room[0] = "";
		}

		if (room[0] == "TW") {
			room[0] = "";
		}

		if (room[1] == "DB") {
			room[1] = "";
		}

		if (room[1] == "TW") {
			room[1] = "";
		}

		if (room[1] == "QD") {
			room[1] = "";
		}
	}

	if (room.length == 5
		&& adults == 5
		&& children == 6) {

		if (room[0] == "DB") {
			room[0] = "";
		}

		if (room[0] == "TW") {
			room[0] = "";
		}

		if (room[0] == "QD") {
			room[0] = "";
		}

		if (room[1] == "DB") {
			room[1] = "";
		}

		if (room[1] == "TW") {
			room[1] = "";
		}

		if (room[1] == "QD") {
			room[1] = "";
		}

		if (room[2] == "SG") {
			room[2] = "";
		}

		if (room[2] == "DB") {
			room[2] = "";
		}

		if (room[2] == "TW") {
			room[2] = "";
		}
	}

	if (room.length == 4
		&& adults == 5
		&& children == 7) {

		if (room[0] == "DBE") {
			room[0] = "";
		}

		if (room[1] == "DB") {
			room[1] = "";
		}

		if (room[1] == "TW") {
			room[1] = "";
		}

	}

	if (room.length == 5
		&& adults == 5
		&& children == 7) {

		if (room[0] == "DBE") {
			room[0] = "";
		}

		if (room[1] == "DB") {
			room[1] = "";
		}

		if (room[1] == "TW") {
			room[1] = "";
		}

		if (room[1] == "QD") {
			room[1] = "";
		}

		if (room[2] == "DB") {
			room[2] = "";
		}

		if (room[2] == "TW") {
			room[2] = "";
		}

		if (room[2] == "QD") {
			room[2] = "";
		}

	}

	if (room.length == 4
		&& adults == 5
		&& children == 8) {

		if (room[0] == "DB") {
			room[0] = "";
		}

		if (room[0] == "TW") {
			room[0] = "";
		}

		if (room[0] == "QD") {
			room[0] = "";
		}
	}


	if (room.length == 5
		&& adults == 5
		&& children == 8) {

		if (room[0] == "DB") {
			room[0] = "";
		}

		if (room[0] == "TW") {
			room[0] = "";
		}

		if (room[1] == "DB") {
			room[1] = "";
		}

		if (room[1] == "TW") {
			room[1] = "";
		}

		if (room[1] == "QD") {
			room[1] = "";
		}

		if (room[2] == "DB") {
			room[2] = "";
		}

		if (room[2] == "TW") {
			room[2] = "";
		}

		if (room[2] == "QD") {
			room[2] = "";
		}
	}

	if (room.length == 4
		&& adults == 5
		&& children == 9) {

		if (room[0] == "DB") {
			room[0] = "";
		}

		if (room[0] == "TW") {
			room[0] = "";
		}
	}


	if (room.length == 5
		&& adults == 5
		&& children == 9) {

		if (room[0] == "DB") {
			room[0] = "";
		}

		if (room[0] == "TW") {
			room[0] = "";
		}

		if (room[0] == "QD") {
			room[0] = "";
		}

		if (room[1] == "DB") {
			room[1] = "";
		}

		if (room[1] == "TW") {
			room[1] = "";
		}

		if (room[1] == "QD") {
			room[1] = "";
		}
	}

	if (room.length == 5
		&& adults == 5
		&& children == 10) {

		if (room[0] == "DB") {
			room[0] = "";
		}

		if (room[0] == "TW") {
			room[0] = "";
		}

		if (room[1] == "DB") {
			room[1] = "";
		}

		if (room[1] == "TW") {
			room[1] = "";
		}
	}

	return room;
}


function fixRoomCombinations6Adults(adults, children, room) {

	if (room.length == 3
		&& adults == 6
		&& children == 1) {
		if (room[0] == "DBE") {
			room[0] = "";
		}

		if (room[0] == "DBE") {
			room[0] = "";
		}
	}

	if (room.length == 4
		&& adults == 6
		&& children == 1) {
		if (room[1] == "DB") {
			room[1] = "";
		}

		if (room[1] == "TW") {
			room[1] = "";
		}
	}

	if (room.length == 4
		&& adults == 6
		&& children == 2) {

		if (room[0] == "DBE") {
			room[0] = "";
		}

		if (room[1] == "DBE") {
			room[1] = "";
		}

		if (room[1] == "DB") {
			room[1] = "";
		}

		if (room[1] == "TW") {
			room[1] = "";
		}
	}

	if (room.length == 5
		&& adults == 6
		&& children == 2) {

		if (room[1] == "DB") {
			room[1] = "";
		}

		if (room[1] == "TW") {
			room[1] = "";
		}
	}

	if (room.length == 4
		&& adults == 6
		&& children == 3) {

		if (room[0] == "DBE") {
			room[0] = "";
		}

		if (room[1] == "DBE") {
			room[1] = "";
		}
	}

	if (room.length == 5
		&& adults == 6
		&& children == 3) {

		if (room[0] == "DBE") {
			room[0] = "";
		}

		if (room[1] == "DBE") {
			room[1] = "";
		}

		if (room[1] == "DB") {
			room[1] = "";
		}

		if (room[1] == "TW") {
			room[1] = "";
		}
	}

	if (room.length == 4
		&& adults == 6
		&& children == 4) {

		if (room[0] == "DB") {
			room[0] = "";
		}

		if (room[0] == "TW") {
			room[0] = "";
		}

		if (room[1] == "DB") {
			room[1] = "";
		}

		if (room[1] == "TW") {
			room[1] = "";
		}

		if (room[2] == "DB") {
			room[2] = "";
		}

		if (room[2] == "TW") {
			room[2] = "";
		}

	}

	if (room.length == 5
		&& adults == 6
		&& children == 4) {

		if (room[0] == "DB") {
			room[0] = "";
		}

		if (room[0] == "TW") {
			room[0] = "";
		}

		if (room[1] == "DB") {
			room[1] = "";
		}

		if (room[1] == "DBE") {
			room[1] = "";
		}

		if (room[1] == "TW") {
			room[1] = "";
		}

		if (room[2] == "DB") {
			room[2] = "";
		}

		if (room[2] == "TW") {
			room[2] = "";
		}

	}

	if (room.length == 4
		&& adults == 6
		&& children == 5) {

		if (room[0] == "DB") {
			room[0] = "";
		}

		if (room[0] == "TW") {
			room[0] = "";
		}

		if (room[1] == "DB") {
			room[1] = "";
		}

		if (room[1] == "TW") {
			room[1] = "";
		}
	}

	if (room.length == 5
		&& adults == 6
		&& children == 5) {

		if (room[0] == "DB") {
			room[0] = "";
		}

		if (room[0] == "TW") {
			room[0] = "";
		}

		if (room[0] == "QD") {
			room[0] = "";
		}

		if (room[1] == "DB") {
			room[1] = "";
		}

		if (room[1] == "TW") {
			room[1] = "";
		}

		if (room[1] == "QD") {
			room[1] = "";
		}

		if (room[2] == "DB") {
			room[2] = "";
		}

		if (room[2] == "TW") {
			room[2] = "";
		}
	}

	if (room.length == 4
		&& adults == 6
		&& children == 6) {

		if (room[1] == "DB") {
			room[1] = "";
		}

		if (room[1] == "TW") {
			room[1] = "";
		}
	}


	if (room.length == 5
		&& adults == 6
		&& children == 6) {

		if (room[1] == "QD") {
			room[1] = "";
		}

		if (room[3] == "TW") {
			room[3] = "";
		}
	}

	if (room.length == 6
		&& adults == 6
		&& children == 7) {

		if (room[3] == "TW") {
			room[3] = "";
		}

		if (room[4] == "TW") {
			room[4] = "";
		}
	}

	return room;
}

function fixRoomCombinations7Adults(adults, children, room){
		
	if(room.length == 4 
			&& adults == 7
			&& children == 2) {
		if(room[0] == "DBE"){
			room[0] = ""
		}

		if (room[2] == "TW") {
			room[2] = ""
		}
	}

	if (room.length == 5
		&& adults == 7
		&& children == 3) {
		if (room[2] == "TW") {
			room[2] = ""
		}
	}

	if (room.length == 5
		&& adults == 7
		&& children == 4) {
		if (room[2] == "TW") {
			room[2] = ""
		}

		if (room[3] == "TW") {
			room[3] = ""
		}
	}

	if (room.length == 4
		&& adults == 7
		&& children == 4) {
		if (room[2] == "QD") {
			room[2] = ""
		}
	}

	return room;
}

function fixRoomCombinations8Adults(adults, children, room) {

	if (room.length == 4
		&& adults == 8
		&& children == 1) {

		if (room[2] == "TW") {
			room[2] = "";
		}
	}

	if (room.length == 5
		&& adults == 8
		&& children == 1) {

		if (room[2] == "TW") {
			room[2] = "";
		}

		if (room[3] == "TW") {
			room[3] = "";
		}
	}

	if (room.length == 4
		&& adults == 8
		&& children == 2) {

		if (room[0] == "QD") {
			room[0] = "";
		}

		if (room[1] == "DBE") {
			room[1] = "";
		}

		if (room[1] == "QD") {
			room[1] = "";
		}

		if (room[2] == "TW") {
			room[2] = "";
		}
	}


	if (room.length == 5
		&& adults == 8
		&& children == 2) {

		if (room[1] == "DB") {
			room[1] = "";
		}

		if (room[1] == "TW") {
			room[1] = "";
		}
	}

	if (room.length == 4
		&& adults == 8
		&& children == 3) {

		if (room[0] == "DBE") {
			room[0] = "";
		}

		if (room[1] == "QD") {
			room[1] = "";
		}
	}

	if (room.length == 5
		&& adults == 8
		&& children == 3) {

		if (room[1] == "DBE") {
			room[1] = "";
		}

		if (room[2] == "QD") {
			room[2] = "";
		}

		if (room[2] == "TW") {
			room[2] = "";
		}
	}

	if (room.length == 6
		&& adults == 8
		&& children == 4) {

		if (room[2] == "TW") {
			room[2] = "";
		}
	}

	if (room.length == 5
		&& adults == 8
		&& children == 5) {

		if (room[2] == "TW") {
			room[2] = "";
		}
	}

	if (room.length == 6
		&& adults == 8
		&& children == 5) {

		if (room[2] == "TW") {
			room[2] = "";
		}

		if (room[3] == "TW") {
			room[3] = "";
		}
	}


	if (room.length == 5
		&& adults == 8
		&& children == 4) {

		if (room[1] == "QD") {
			room[1] = "";
		}

		if (room[2] == "TW") {
			room[2] = "";
		}

		if (room[3] == "TW") {
			room[3] = "";
		}
	}


	if (room.length == 5
		&& adults == 8
		&& children == 6) {

		if (room[2] == "TW") {
			room[2] = "";
		}
	}

	if (room.length == 6
		&& adults == 8
		&& children == 6) {

		if (room[2] == "TW") {
			room[2] = "";
		}

		if (room[3] == "TW") {
			room[3] = "";
		}
	}

	if (room.length == 6
		&& adults == 8
		&& children == 7) {

		if (room[2] == "TW") {
			room[2] = "";
		}

		if (room[3] == "TW") {
			room[3] = "";
		}
	}

	if (room.length == 6
		&& adults == 8
		&& children == 8) {

		if (room[2] == "TW") {
			room[2] = "";
		}

		if (room[3] == "TW") {
			room[3] = "";
		}
	}

	if (room.length == 7
		&& adults == 8
		&& children == 8) {

		if (room[2] == "TW") {
			room[2] = "";
		}

		if (room[3] == "TW") {
			room[3] = "";
		}
	}

	if (room.length == 6
		&& adults == 8
		&& children == 9) {

		if (room[2] == "TW") {
			room[2] = "";
		}
	}

	if (room.length == 7
		&& adults == 8
		&& children == 9) {

		if (room[2] == "TW") {
			room[2] = "";
		}

		if (room[3] == "TW") {
			room[3] = "";
		}
	}

	if (room.length == 7
		&& adults == 8
		&& children == 10) {

		if (room[2] == "TW") {
			room[2] = "";
		}

		if (room[3] == "TW") {
			room[3] = "";
		}
	}

	return room;
}

function fixRoomCombinations9Adults(adults, children, room) {

	if (room.length == 4
		&& adults == 9
		&& children == 1) {

		if (room[0] == "DBE") {
			room[0] = "";
		}

		if (room[1] == "DBE") {
			room[1] = "";
		}

		if (room[2] == "DBE") {
			room[2] = "TR";
		}

		if (room[1] == "QD") {
			room[1] = "";
		}

		if (room[2] == "QD") {
			room[2] = "";
		}
	}

	if (room.length == 5
		&& adults == 9
		&& children == 1) {

		if (room[1] == "DBE") {
			room[1] = "";
		}
	}

	if (room.length == 5
		&& adults == 9
		&& children == 2) {

		if (room[1] == "DB") {
			room[1] = "";
		}

		if (room[1] == "TW") {
			room[1] = "";
		}

		if (room[2] == "QD") {
			room[2] = "";
		}
	}

	if (room.length == 4
		&& adults == 9
		&& children == 2) {

		if (room[0] == "DBE") {
			room[0] = "";
		}

		if (room[1] == "DBE") {
			room[1] = "";
		}

		if (room[2] == "DBE") {
			room[2] = "TR";
		}

		if (room[3] == "SG") {
			room[3] = "";
		}

		if (room[1] == "QD") {
			room[1] = "";
		}

		if (room[2] == "QD") {
			room[2] = "";
		}

	}

	if (room.length == 4
		&& adults == 9
		&& children == 3) {

		if (room[0] == "DBE") {
			room[0] = "";
		}

		if (room[1] == "DB" || room[1] == "TW") {
			room[1] = "";
		}

		if (room[1] == "DBE") {
			room[1] = "TR";
		}

		if (room[2] == "TR") {
			room[2] = "DBE";
		}

		if (room[3] == "SG") {
			room[3] = "";
		}

		if (room[1] == "QD") {
			room[1] = "";
		}

		if (room[2] == "QD") {
			room[2] = "";
		}

	}

	if (room.length == 4
		&& adults == 9
		&& children == 4) {

		if (room[1] == "DBE") {
			room[1] = "TR";
		}
	}

	if (room.length == 4
		&& adults == 9
		&& children == 5) {

		if (room[0] == "DBE") {
			room[0] = "TR";
		}
	}

	if (room.length == 6
		&& adults == 9
		&& children == 5) {

		if (room[1] == "DBE") {
			room[1] = "";
		}
	}

	if (room.length == 7
		&& adults == 9
		&& children == 5) {

		if (room[3] == "DBE") {
			room[3] = "";
		}
	}

	if (room.length == 5
		&& adults == 9
		&& children == 6) {

		if (room[0] == "DB" || room[0] == "TW") {
			room[0] = "";
		}

		if (room[1] == "DB" || room[1] == "TW") {
			room[1] = "";
		}

		if (room[0] == "DBE") {
			room[0] = "TR";
		}

		if (room[2] == "DBE") {
			room[2] = "";
		}

		if (room[4] == "QD") {
			room[4] = "";
		}
	}

	if (room.length == 7
		&& adults == 9
		&& children == 7) {

		if (room[3] == "QD") {
			room[3] = "";
		}
	}

	if (room.length == 7
		&& adults == 9
		&& children == 10) {

		if (room[2] == "TW") {
			room[2] = "";
		}

		if (room[3] == "TW") {
			room[3] = "";
		}
	}

	return room;
}

function fixRoomCombinations10Adults(adults, children, room) {

	if (room.length == 5
		&& adults == 10
		&& children == 1) {

		if (room[2] == "DBE") {
			room[2] = "TR";
		}

		if (room[2] == "TW") {
			room[2] = "";
		}

		if (room[3] == "TW") {
			room[3] = "";
		}

		if (room[4] == "DBE") {
			room[4] = "";
		}
	}

	if (room.length == 5
		&& adults == 10
		&& children == 2) {

		if (room[0] == "DBE") {
			room[0] = "";
		}

		if (room[1] == "DB" || room[1] == "TW") {
			room[1] = "";
		}

		if (room[1] == "QD") {
			room[1] = "";
		}

		if (room[1] == "DBE") {
			room[1] = "TR";
		}

		if (room[2] == "TW") {
			room[2] = "";
		}

		if (room[3] == "SG") {
			room[3] = "";
		}

		if (room[3] == "TW") {
			room[3] = "";
		}

		if (room[3] == "QD") {
			room[3] = "";
		}

		if (room[2] == "QD") {
			room[2] = "";
		}

		if (room[4] == "QD") {
			room[4] = "";
		}

		if (room[4] == "DBE") {
			room[4] = "";
		}
	}


	if (room.length == 5
		&& adults == 10
		&& children == 3) {

		if (room[0] == "DBE") {
			room[0] = "";
		}

		if (room[1] == "DB" || room[1] == "TW") {
			room[1] = "";
		}

		if (room[1] == "QD") {
			room[1] = "";
		}

		if (room[1] == "DBE") {
			room[1] = "TR";
		}

		if (room[2] == "TW") {
			room[2] = "";
		}

		if (room[2] == "QD") {
			room[2] = "";
		}

		if (room[3] == "SG") {
			room[3] = "";
		}

		if (room[3] == "TW") {
			room[3] = "";
		}

		if (room[3] == "SG") {
			room[3] = "";
		}

		if (room[4] == "QD") {
			room[4] = "";
		}

		if (room[4] == "DBE") {
			room[4] = "";
		}
	}

	if (room.length == 5
		&& adults == 10
		&& children == 4) {

		if (room[1] == "DBE") {
			room[1] = "";
		}

		if (room[2] == "TW") {
			room[2] = "";
		}

		if (room[2] == "QD") {
			room[2] = "";
		}

		if (room[3] == "QD") {
			room[3] = "";
		}

		if (room[4] == "SG") {
			room[4] = "";
		}

	}

	if (room.length == 7
		&& adults == 10
		&& children == 7) {

		if (room[2] == "DBE") {
			room[2] = "";
		}

		if (room[3] == "DBE") {
			room[3] = "";
		}

		if (room[3] == "QD") {
			room[3] = "";
		}
	}

	if (room.length == 8
		&& adults == 10
		&& children == 8) {

		if (room[3] == "DBE") {
			room[3] = "";
		}
	}

	if (room.length == 5
		&& adults == 10
		&& children == 5) {

		if (room[0] == "DBE") {
			room[0] = "";
		}

		if (room[1] == "DBE") {
			room[1] = "";
		}

		if (room[2] == "QD") {
			room[2] = "";
		}

		if (room[4] == "SG") {
			room[4] = "";
		}
	}

	if (room.length == 6
		&& adults == 10
		&& children == 7) {

		if (room[1] == "DB" || room[1] == "TW") {
			room[1] = "";
		}

		if (room[2] == "TW") {
			room[2] = "";
		}

		if (room[3] == "DBE") {
			room[3] = "";
		}

		if (room[5] == "QD") {
			room[5] = "";
		}
	}

	if (room.length == 7
		&& adults == 10
		&& children == 9) {

		if (room[2] == "TW") {
			room[2] = "";
		}

		if (room[3] == "TW") {
			room[3] = "";
		}

		if (room[4] == "DBE") {
			room[4] = "";
		}

		if (room[6] == "QD") {
			room[6] = "";
		}
	}

	return room;
}

//Fix some room combinations because of the rooms
function fixRoomCombinations(adults, children, rooms){
		
	if(adults == 7 && children == 0) {
		rooms.push(["DB", "DB", "TR"]);
		rooms.push(["TW", "TW", "XX"]);
		rooms.push(["SG", "TR", "XX"]);
	} else if(adults == 8 && children == 0) {
		rooms = [];
		rooms.push(["TR", "TR", "DB"]);
		rooms.push(["XX", "XX", "TW"]);
		rooms.push(["DB", "DB", "DB", "DB"]);
		rooms.push(["TW", "TW", "TW", "TW"]);
		rooms.push(["TR", "SG", "SG", "SG", "SG", "SG"]);
		rooms.push(["DB", "DB", "XX", "XX", "XX", "XX"]);
		rooms.push(["TW", "TW", "XX", "XX", "XX", "XX"]);
	} else if (adults == 10 && children == 0) {
		rooms = [];
		rooms.push(["DB", "DB", "DB", "DB", "DB"]);
		rooms.push(["TW", "TW", "TW", "TW", "TW"]);
		rooms.push(["DB", "DB", "DB", "DB", "SG", "SG"]);
		rooms.push(["TW", "TW", "TW", "TW", "XX", "XX"]);
		rooms.push(["SG", "SG", "SG", "SG", "SG", "SG", "SG", "SG", "SG", "SG"]);
	}	
		
	rooms.forEach(function(room){
		
		switch(adults) {
			case 5:
				room = fixRoomCombinations5Adults(adults, children, room);
				break;
			case 6:
				room = fixRoomCombinations6Adults(adults, children, room);
				break;
			case 7:
				room = fixRoomCombinations7Adults(adults, children, room);
				break;
			case 8:
				room = fixRoomCombinations8Adults(adults, children, room);
				break;
			case 9:
				room = fixRoomCombinations9Adults(adults, children, room);
				break;
			case 10:
				room = fixRoomCombinations10Adults(adults, children, room);
				break;
		}
	});

	return rooms;
}

//Filter combinations that have the same travelers
function getRoomsAvailables(adults, children, infants) {

	var rooms = [];

	if (!(adults > 0)) {
		return rooms;
	}

	var tourRooms = []

	var roomsConfig = [];
	var onlyAdults = false;
	if ((adults > 0) && (children == 0)) {
		onlyAdults = true;
	}

	var more2Children = false;
	if (children >= 2) {
		more2Children = true;
	}

	//Get the rooms of tours
	$("[data-booking='roomType']").sort(sortByGuests).each(function () {

		var maxPeople = 0;
		if ($(this).data("tourplan-type").trim() == "SG") {
			maxPeople = 1;
		}
		if ($(this).data("tourplan-type").trim() == "DB") {
			maxPeople = 2;
		}
		if ($(this).data("tourplan-type").trim() == "TW") {
			maxPeople = 2;
		}
		if ($(this).data("tourplan-type").trim() == "TR") {
			maxPeople = 3;
		}
		if ($(this).data("tourplan-type").trim() == "DBE") {
			maxPeople = 3;
		}
		if ($(this).data("tourplan-type").trim() == "QD") {
			maxPeople = 4;
		}

		if (($(this).data("tourplan-type").trim() == "TR") && !onlyAdults) {
			return;
		}

		if (($(this).data("tourplan-type").trim() == "DBE") && onlyAdults) {
			return;
		}

		if (($(this).data("tourplan-type").trim() == "QD") && (onlyAdults || !more2Children)) {
			return;
		}

		tourRooms.push($(this).data("tourplan-type").trim());

		roomsConfig.push({
			val: $(this).val(),
			description: $(this).data("description").trim(),
			maxPeople: maxPeople,
			maxGuests: $(this).data("max-guests"),
			tourplanType: $(this).data("tourplan-type").trim(),
			name: $(this).data("name").trim()
		});
	});

	var travelers = adults + children;

	var roomsCombinations = getRoomsCombinations(adults, tourRooms);

	for (var i = 0; i < roomsCombinations.length; i++) {
		var total = 0;

		for (var j = 0; j < roomsCombinations[i].length; j++) {
			roomsConfig.forEach(function (item) {
				if (item.tourplanType == roomsCombinations[i][j]) {
					total = total + parseInt(item.maxPeople);
				}
			});
		}

		if (total == travelers) {
			var index = -1
			for (j = 0; j < rooms.length; j++) {
				if (rooms[j].sort().toString() == roomsCombinations[i].sort().toString()) {
					index = j;
					break;
				}
			}

			if (index < 0) {
				rooms.push(roomsCombinations[i]);
			}
		}
	}

	rooms = removeRoomCombinations(this, adults, children, rooms);

	rooms = sortCombinationsByAdults(rooms);

	removedDuplicatedCombinations(rooms);

	rooms = fixRoomCombinations(adults, children, rooms);

	return rooms;
}




// WEBPACK FOOTER //
// ./src/main/resources/assets/js/authentic/rooms.js